/**
 * Part of toolstool project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@main';

const relatedSwiper = new Swiper('.j-related-swiper', {
  speed: 1000,
  loop: false,
  slidesPerView: 2,
  spaceBetween: 10,
  slidesPerGroup: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-dots',
    clickable: true,
    type: 'bullets',
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerGroup: 2,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
    }
  }
});

// Product Variant
import { AppPlugin } from '@/vue/app-plugin.js?c412f122d640a7dd5ac13178';
const { ref, reactive, watch, onMounted, computed, toRefs, createApp } = Vue;

const app = createApp({
  name: 'ProductItem',
  setup(props) {
    const state = reactive({
      item: u.data('item'),
      defaultVariant: u.data('default_variant'),
      minPriceVariant: u.data('min_price_variant'),
      variants: u.data('variants'),
      specs: u.data('specs'),

      current: {
        priceSet: {},
        inventory: 0
      },
      hasClick: false,
      quantity: 1,
      selectedVariant: null,
      warning: null,
      currentOverlay: '',
      inited: false
    });

    for (const spec of state.specs) {
      spec.selected = null;
    }

    state.current.priceSet = state.defaultVariant.priceSet;
    state.current.inventory = state.defaultVariant.inventory;

    onMounted(() => {
      if (state.variants.length === 0) {
        state.selectedVariant = state.defaultVariant;
      }

      updateWarning();

      setTimeout(() => {
        state.inited = true;
      }, 10);

      u.trigger('load.share.this');
    });

    // Specs
    const availableSpecs = computed(() => {
      const specs = [];

      if (hasSpecOptions(state.specs[0])) {
        specs.push(state.specs[0]);
      }

      if (hasSpecOptions(state.specs[1])) {
        specs.push(state.specs[1]);
      }

      return specs;
    });

    // Options
    function specButtonClicked(spec, option) {
      spec.selected = option.uid;

      state.hasClick = true;
    }

    function hasSpecOptions(spec) {
      if (!spec) {
        return false;
      }

      if (!spec.title) {
        return false;
      }

      return spec.options.filter(option => option.text !== '').length > 0;
    }

    const selectedSpecOptions = computed(() => {
      return state.specs.map((spec) => spec.selected);
    });

    watch(() => selectedSpecOptions, () => {
      const hash = getHash(selectedSpecOptions.value[0], selectedSpecOptions.value[1]);

      state.selectedVariant = state.variants[hash];
    }, { deep: true });

    watch(() => state.selectedVariant, () => {
      if (state.selectedVariant) {
        state.current.priceSet = state.selectedVariant.priceSet;
        state.current.inventory = state.selectedVariant.inventory;
      }

      updateWarning();
    });

    function getHash(a, b) {
      if (a === b) {
        b = '';
      }

      return u.md5((a || '') + (b || ''));
    }

    // Images
    function mouseOver(option, i) {
      if (i > 0) {
        return;
      }

      const img = $('.l-product-image-overlay');

      if (option.cover) {
        if (state.currentOverlay !== option.cover) {
          // To support mobile variant images
          state.hasClick = false;
        }

        state.currentOverlay = option.cover;
        img[0].style.backgroundImage = `url('${option.cover}')`;

        img.show();
      }
    }

    function mouseOut() {
      if (state.hasClick) {
        return;
      }

      $('.l-product-image-overlay').hide();
    }

    // Product Cart
    const canAddToCart = computed(() => {
      return !Boolean(state.warning);
    });

    watch(() => state.quantity, () => {
      updateWarning();
    });

    function updateWarning() {
      if (state.current.priceSet.final.price <= 0) {
        state.warning = ' ';
        return;
      }

      if (Object.values(state.variants).length > 0 && !state.selectedVariant) {
        state.warning = '請先選擇規格才能結帳';
        return;
      }

      if (state.current.inventory < state.quantity) {
        state.warning = '庫存不足';
        return;
      }

      state.warning = null;
    }

    return {
      ...toRefs(state),
      canAddToCart,
      selectedSpecOptions,
      availableSpecs,

      hasSpecOptions,
      specButtonClicked,
      mouseOver,
      mouseOut,
    };
  }
});
app.use(AppPlugin);
app.mount('#c-product-actions');
